import { render, staticRenderFns } from "./LastSubmittedOrderModal.vue?vue&type=template&id=628d34cd"
import script from "./LastSubmittedOrderModal.vue?vue&type=script&lang=js"
export * from "./LastSubmittedOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports